export default __webpack_public_path__ + "static/media/whitening.dc2544d4.png";